// use-album-modal-store.ts
// Zustand store to coordinate between CKEditor ImageAlbumPlugin
// and the React ImageAlbumModal component

import { create } from "zustand"

export type AlbumLayout = "grid" | "masonry" | "slider"

export interface AlbumImage {
  url: string
  /** Bản hiển thị trong album (medium/large) — nét hơn thumbnail nhưng nhẹ hơn ảnh gốc. */
  display?: string
  thumbnail?: string
  alt: string
  name?: string
  id?: number
}

interface AlbumModalStore {
  isOpen: boolean
  layout: AlbumLayout
  editorRef: any | null
  editingAlbum?: {
    element: HTMLElement | null
    images: AlbumImage[]
    layout: AlbumLayout
  }

  open: (opts: { layout?: AlbumLayout; editorRef: any; editingAlbum?: { element: HTMLElement | null; images: AlbumImage[]; layout: AlbumLayout } }) => void
  close: () => void
}

export const useAlbumModalStore = create<AlbumModalStore>((set) => ({
  isOpen: false,
  layout: "grid",
  editorRef: null,
  editingAlbum: undefined,

  open: ({ layout = "grid", editorRef, editingAlbum }) =>
    set({ isOpen: true, layout, editorRef, editingAlbum }),

  close: () => set({ isOpen: false, editorRef: null, editingAlbum: undefined }),
}))
